import classNames from 'classnames'
import { graphql, Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import React, { ReactNode } from 'react'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode[] | ReactNode | string
  icon?: Queries.ButtonFragment['icon']
  kind?: 'anchor' | 'button'
  appearance?: 'hollow' | 'solid' | 'hollow-white'
  to?: string
  className?: string
}

const Button: React.FC<ButtonProps> = ({ children, className = '', kind = 'button', appearance = 'solid', icon, to, ...props }) => {
  const buttonClass = classNames('rounded-full px-5 py-2 md:px-8 md:py-4 text-xl md:text-2xl font-title text-white whitespace-nowrap uppercase', {
    'bg-blue-400 bg-gradient-to-r from-c-button-gradient-left to-c-button-gradient-right': appearance === 'solid',
    'hover:border-c-button-pink hover:text-c-button-pink border-c-button-blue border-4 text-c-button-blue': appearance === 'hollow',
    'hover:border-c-button-pink hover:text-c-button-pink border-white border-4 text-white': appearance === 'hollow-white',
    [className]: classNames
  })

  if (kind === 'anchor' && to) {
    if (icon != null) {
      return (
        <Link className={buttonClass} to={to}>
          <div className='inline-flex gap-x-3'>
            <div>{children}</div>
            {/*<div className='flex items-center'>{icon.gatsbyImageData != null && <GatsbyImage alt='Icon' image={icon.gatsbyImageData} />}</div>*/}
          </div>
        </Link>
      )
    } else {
      return (
        <Link className={buttonClass} to={to}>
          {children}
        </Link>
      )
    }
  } else if (kind === 'button') {
    return (
      <button className={buttonClass} {...props}>
        {children}
      </button>
    )
  } else {
    return <>{children}</>
  }
}

export default Button

export const fragmentBlocks = graphql`
  fragment Button on ContentfulButton {
    __typename
    title
    url
    icon
  }
`
